import { trackIdentify } from '@/services/signup/api';
import type { SignupFormValues } from '../types';
import type { SignupStep } from './steps';

/**
 * The server-side marketing identify rides on the entry- and company-step
 * transitions only. Startup signups collect company details on the entry step
 * (and skip the company step), so their company-level traits ride with the
 * entry identify. Any other step carries no identify. Only the server's nine
 * wire traits are sent (see `SignupIdentifyAttrs`) — the extras historically
 * passed on these transitions were discarded at unmarshal server-side, dead
 * on the wire. Fired by the flow engine's `goToNextStep` — never by step UIs.
 */
export function trackSignupProgress(
  finishedStep: SignupStep,
  values: SignupFormValues,
  flow: { isStartup: boolean; effectiveSignupType: string },
): void {
  if (finishedStep === 'index') {
    if (flow.isStartup) {
      trackIdentify({
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        companyName: values.companyName,
        acceptTerms: values.acceptTerms,
      });
      return;
    }
    trackIdentify({
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
    });
    return;
  }

  if (finishedStep === 'company') {
    trackIdentify({
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      companyName: values.companyName,
      workPhone: values.workPhone,
      acceptTerms: values.acceptTerms,
    });
  }
}
